// find moment locale codes here: 

import { ViewModuleOutlined } from "@mui/icons-material"

// https://stackoverflow.com/questions/31109303/how-to-obtain-a-list-of-available-locale-keys-from-momentjs-with-locale
const languageConfig = [
  { 
    code: 'en', 
    name: 'English', 
    nameInLanguage: 'English', 
    branchLanguage: true, 
    momentLocale: 'en',
    keepProperNouns: false,
    googleTranslationCode: 'en',
    machineTranslation: false,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'es', 
    name: 'Spanish', 
    nameInLanguage: 'Español', 
    branchLanguage: true, 
    momentLocale: 'es',
    keepProperNouns: true,
    googleTranslationCode: 'es',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'pt', 
    name: 'Portuguese', 
    nameInLanguage: 'Português', 
    branchLanguage: true, 
    momentLocale: 'pt-br',
    keepProperNouns: true,
    googleTranslationCode: 'pt-BR',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'ko', 
    name: 'Korean', 
    nameInLanguage: '한국어', 
    branchLanguage: true, 
    momentLocale: 'ko',
    keepProperNouns: false,
    googleTranslationCode: 'ko',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'zh', 
    name: 'Chinese (Simplified)', 
    nameInLanguage: '简体中文', 
    branchLanguage: true, 
    momentLocale: 'zh-cn',
    keepProperNouns: false,
    googleTranslationCode: 'zh-CN',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'zh-TW', 
    name: 'Chinese (Traditional)', 
    nameInLanguage: '繁體中文', 
    branchLanguage: true, 
    momentLocale: 'zh-tw',
    keepProperNouns: false,
    googleTranslationCode: 'zh-TW',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'vi', 
    name: 'Vietnamese', 
    nameInLanguage: 'Tiếng Việt', 
    branchLanguage: false, 
    momentLocale: 'vi',
    keepProperNouns: true,
    googleTranslationCode: 'vi',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  { 
    code: 'hi', 
    name: 'Hindi', 
    nameInLanguage: 'हिंदी', 
    branchLanguage: false, 
    momentLocale: 'hi',
    keepProperNouns: false,
    googleTranslationCode: 'hi',
    machineTranslation: true,
    onlyPartialTranslation: true,
    translationEngine: 'google'
  },
  {
    code: 'gu', 
    name: 'Gujarati', 
    nameInLanguage: 'ગુજરાતી', 
    branchLanguage: false, 
    momentLocale: 'gu',
    keepProperNouns: false,
    googleTranslationCode: 'gu',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'pa', 
    name: 'Punjabi', 
    nameInLanguage: 'ਪੰਜਾਬੀ', 
    branchLanguage: false, 
    momentLocale: 'pa-in',
    keepProperNouns: false,
    googleTranslationCode: 'pa',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'te',
    name: 'Telugu',
    nameInLanguage: 'తెలుగు',
    branchLanguage: false,
    momentLocale: 'te',
    keepProperNouns: false,
    googleTranslationCode: 'te',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'ur',
    name: 'Urdu',
    nameInLanguage: 'اُردُو',
    branchLanguage: false,
    momentLocale: 'ur',
    keepProperNouns: false,
    googleTranslationCode: 'ur',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'ar',
    name: 'Arabic',
    nameInLanguage: 'العربية',
    branchLanguage: false,
    momentLocale: 'ar',
    keepProperNouns: false,
    googleTranslationCode: 'ar',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'fr',
    name: 'French',
    nameInLanguage: 'Français',
    branchLanguage: false,
    momentLocale: 'fr',
    keepProperNouns: true,
    googleTranslationCode: 'fr',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'so',
    name: 'Somali',
    nameInLanguage: 'Soomaali',
    branchLanguage: false,
    momentLocale: 'en',
    keepProperNouns: true,
    googleTranslationCode: 'so',
    machineTranslation: true,
    onlyPartialTranslation: true,
    translationEngine: 'google'
  },
  {
    code: 'sw',
    name: 'Swahili',
    nameInLanguage: 'Kiswahili',
    branchLanguage: false,
    momentLocale: 'sw',
    keepProperNouns: true,
    googleTranslationCode: 'sw',
    machineTranslation: true,
    onlyPartialTranslation: true,
    translationEngine: 'google'
  },
  {
    code: 'ne',
    name: 'Nepali',
    nameInLanguage: 'नेपाली',
    branchLanguage: false,
    momentLocale: 'ne',
    keepProperNouns: false,
    googleTranslationCode: 'ne',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'google'
  },
  {
    code: 'kar',
    name: 'Karen',
    nameInLanguage: 'ကညီ',
    branchLanguage: false,
    momentLocale: 'my',
    keepProperNouns: false,
    googleTranslationCode: null,
    machineTranslation: false,
    onlyPartialTranslation: true,
    translationEngine: 'google'
  },
  {
    code: 'tl',
    name: 'Tagalog',
    nameInLanguage: 'Tagalog',
    branchLanguage: false,
    momentLocale: 'tl-ph',
    keepProperNouns: false,
    googleTranslationCode: null,
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'chatgpt'
  },
  {
    code: 'bn',
    name: 'Bengali',
    nameInLanguage: 'বাংলা',
    branchLanguage: false,
    momentLocale: 'bn',
    keepProperNouns: false,
    googleTranslationCode: 'bn',
    machineTranslation: true,
    onlyPartialTranslation: false,
    translationEngine: 'chatgpt'
  },
  {
    code: 'hmn',
    name: 'Hmong',
    nameInLanguage: 'Hmoob',
    branchLanguage: false,
    momentLocale: 'en',
    keepProperNouns: false,
    googleTranslationCode: null,
    machineTranslation: false,
    onlyPartialTranslation: true,
    translationEngine: 'google'
  },
]

export { languageConfig };